// @ts-strict-ignore
import {
	CloseButton,
	context,
	InstantConfigService,
	SlotTweaker,
	TEMPLATE,
	TemplateStateHandler,
	TemplateTransition,
	type AdSlot,
	universalAdPackage,
} from '@wikia/ad-engine';
import { Inject, Injectable } from '@wikia/dependency-injection';

@Injectable({ autobind: false })
export class FloorAdhesionCloseButtonHandler implements TemplateStateHandler {
	private button: HTMLButtonElement;
	private readonly showCloseButtonAfter?: number;
	private readonly hideCloseButton?: boolean;

	constructor(
		@Inject(TEMPLATE.SLOT) private adSlot: AdSlot,
		private instantConfig: InstantConfigService,
	) {
		this.hideCloseButton = context.get('hideAdhesionCloseButton');
		this.showCloseButtonAfter = instantConfig.get('icFloorAdhesionTimeToCloseButton', 0);
	}

	async onEnter(transition: TemplateTransition<'hidden'>): Promise<void> {
		// remove previous close button if exists
		document.querySelector('.floor-adhesion-close-button')?.remove();

		if (!this.shouldCloseButtonBeAttached()) {
			return;
		}

		if (!this.hideCloseButton) {
			this.button = new CloseButton({
				onClick: () => {
					this.adSlot.emitEvent(SlotTweaker.SLOT_CLOSE_IMMEDIATELY);
					transition('hidden');
				},
				classNames: ['floor-adhesion-close-button'],
			}).render();

			setTimeout(() => {
				this.adSlot.getElement().insertAdjacentElement('afterend', this.button);
			}, this.showCloseButtonAfter);
		} else {
			const floorAdhesionAnchor = document.getElementById('floor_adhesion_container');

			// Add the persistent adhesion styles
			floorAdhesionAnchor?.classList.add('persistent');
			if (context.get('wiki.isDarkTheme')) {
				// Add dark theme wiki style
				floorAdhesionAnchor?.classList.add('is-dark');
			} else {
				// Add dark theme wiki style
				floorAdhesionAnchor?.classList.add('is-light');
			}
		}
	}

	async onLeave(): Promise<void> {
		this?.button?.remove();
	}

	private shouldCloseButtonBeAttached(): boolean {
		if (universalAdPackage.isFanTakeoverLoaded()) {
			return true;
		}

		return (
			this.adSlot.getIframeSize().height >=
			this.instantConfig.get('icFloorCloseButtonAttachHeightThreshold', 99)
		);
	}
}
